export const DESC_SIGN = '-';

export const PAGINATION_SIZE_OPTIONS = [
  { value: 5, label: 5 },
  { value: 10, label: 10 },
  { value: 20, label: 20 },
  { value: 30, label: 30 },
  { value: 50, label: 50 }
];

export const DEFAULT_PAGE_SIZE = PAGINATION_SIZE_OPTIONS[1].value;
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGINATION = {
  page: DEFAULT_PAGE,
  size: DEFAULT_PAGE_SIZE
};

export const PAGINATION_TO_URL = {
  page: 'page',
  size: 'pageSize',
  sort: 'sort'
};

export const PAGINATION_MAPPINGS = {
  DEFAULT: {
    size: '_page.pageSize',
    total: '_page.totalElements',
    page: '_page.page'
  },
  DOSSIERS: {
    size: '_page.size',
    total: '_page.totalElements',
    page: '_page.number'
  }
};

export const ORDER_CHANGE_DIRECTION = {
  UP: 'up',
  DOWN: 'down'
};
